import { ContentItem, Elements } from '@kentico/kontent-delivery'

/**
 * Generated by '@kentico/kontent-model-generator@3.2.0'
 * Tip: You can replace 'ContentItem' with another generated class to fully leverage strong typing.
 */
export class Tab extends ContentItem {
  public tabName: Elements.RichTextElement
  public id: Elements.TextElement
  public tabContent: Elements.RichTextElement
  constructor() {
    super({
      propertyResolver: (elementName: string) => {
        if (elementName === 'tab_name') {
          return 'tabName'
        }
        if (elementName === 'tab_content') {
          return 'tabContent'
        }
        return elementName
      },
    })
  }
}
